<template>
	<div class="d-flex align-items-center commanfilter">
        <div class="has-search mr-3 mb-0 position-relative" v-if="searchFilter != 'disable'">
            <feather type="search" class="form-control-feedback"></feather> 
            <input type="text" class="form-control"  :placeholder="($parent.pagename && ($parent.pagename == 'deposit-list' || $parent.pagename == 'withdrawal-list'))? 'search by account id' : $t('search')"  v-model="search" @keyup="searchFilterFun()">
        </div>  
        <select class="form-control filterslect mr-2" v-model="limit" @change="limitFilterFunc()" v-if="limitFilter != 'disable'">
        	<option value="15">15</option>
        	<option value="30">30</option>
        	<option value="50">50</option>
        </select> 
		<div class="d-flex align-items-center reportSlectDate" v-if="pageTitle == 'Economic-Calender'">
			<div class="form-group has-search mb-0 position-relative">
					<select v-model="$parent.offset" class="form-control filterslect mr-2">
						<option value="">{{$t('filter_Selecttimezone')}}</option>
						<option :value="list.val" v-for="list in timezone">{{list.text}}</option>
					</select>
			</div>
			<div class="form-group has-search mb-0 position-relative">
				<datepicker class=" " v-model="fromDateField" placeholder="Enter From Date" format="YYYY-MM-DD" :lang="lang" ></datepicker>
			</div>
			<div class="form-group has-search mx-2 mb-0 position-relative">
				<datepicker class=" " v-model="toDateField" placeholder="Enter To Date" ormat="YYYY-MM-DD"  :lang="lang"></datepicker>
			</div>
			<select class="form-control filterslect mr-2" v-model="priority">
				<!-- <option value="-1">{{$t('all')}}</option> -->
				<option value="1">{{$t('filter_Low')}}</option>
				<option value="2">{{$t('filter_medium')}}</option>
				<option value="3">{{$t('filter_high')}}</option>
			</select> 
			<div class="form-group has-search mb-0 position-relative" >
				<a href="#" class="prism_btn btn_sm grd_btn" @click.prevent="dateFormat()"  >
					{{$t('filter_submit')}}
				</a>
			</div>
		</div>
		<div class="d-flex align-items-center reportSlectDate" v-if="pageTitle == 'close-trade' && lastSelectTradingAccount != ''">
			<div class="form-group has-search mb-0 position-relative">
				<datepicker class=" " v-model="fromDateField1" placeholder="Enter From Date"  type="datetime"    :lang="lang" ></datepicker>
			</div>
			<div class="form-group has-search mx-2 mb-0 position-relative">
				<datepicker class=" " v-model="toDateField1" placeholder="Enter To Date"  type="datetime"    :lang="lang"></datepicker>
			</div>
			 
			<div class="form-group has-search mb-0 position-relative" >
				<a href="#" class="prism_btn btn_sm grd_btn" @click.prevent="dateFormat1()"  :class="(fromDateField1 != '' && toDateField1 != '' && toDateField1 != 'Invalid date' && fromDateField1 != 'Invalid date')?'':'disabled'">
					{{$t('filter_submit')}}
				</a>
			</div>
		</div>
	</div>
</template>
<script>      
    import { fxViewMixins } from '@/plugins/fxView'  
	import moment from 'moment'
    export default {
        name: 'Filters',
        mixins: [fxViewMixins],
        data () {
          return {
           	'search' :'',
           	'limit' : '15',
			//======================calender========================
			lang: {
				formatLocale: {
					firstDayOfWeek: 1,
				},
				monthBeforeYear: false,
			},
			toDateField : '',
			fromDateField : '',
			
			toDateField1 : '',
			fromDateField1 : '',
			priority : '1',
			timezone :[
				{text:'UTC -12',val:'-12'},{text:'UTC -11',val:'-11'},{text:'UTC -10',val:'-10'},{text:'UTC -9',val:'-9'},{text:'UTC -8',val:'-8'},{text:'UTC -7',val:'-7'},{text:'UTC -6',val:'-6'},{text:'UTC -5',val:'-5'},{text:'UTC -4',val:'-4'},{text:'UTC -3',val:'-3'},{text:'UTC -2',val:'-2'},{text:'UTC -1',val:'-1'},{text:'UTC',val:'0'},{text:'UTC +1',val:'+1'},{text:'UTC +2',val:'+2'},{text:'UTC +3',val:'+3'},{text:'UTC +3:30',val:'+3.5'},{text:'UTC +4',val:'+4'},{text:'UTC +4:30',val:'+4.5'},{text:'UTC +5',val:'+5'},{text:'UTC +5:30',val:'+5.5'},{text:'UTC +5:45',val:'+5.75'},{text:'UTC +6',val:'+6'},{text:'UTC +7',val:'+7'},{text:'UTC +8',val:'+8'},{text:'UTC +9',val:'+9'},{text:'UTC +9:30',val:'+9.5'},{text:'UTC +10',val:'+10'},{text:'UTC +10:30',val:'+10.5'},{text:'UTC +11',val:'+11'},{text:'UTC +12',val:'+12'},{text:'UTC +13',val:'+13'},{text:'UTC +14',val:'+14'},
			]
          }
        }, 
        props:['searchFilter' ,'limitFilter','pageTitle'],
        methods:{
			dateFormat1(){
				if(this.fromDateField1 != '' && this.fromDateField1 != 'Invalid date'){
					this.$parent.fromDateField =  moment(this.fromDateField1).unix()
				}if(this.toDateField1 != '' && this.toDateField1 != 'Invalid date'){
					this.$parent.toDateField = moment(this.toDateField1).unix()
				}if(this.fromDateField1 == '' || this.fromDateField1 == 'Invalid date'){
					this.$parent.fromDateField =  ''
				}if(this.toDateField1 == '' || this.toDateField1 == 'Invalid date'){
					this.$parent.toDateField =  ''
				}
				this.$parent.listing()
			},
			dateFormat(){
				this.$parent.priority = this.priority
				if(this.fromDateField != '' && this.fromDateField != 'Invalid date'){
					this.$parent.fromDateField =  moment(this.fromDateField).format('YYYY-MM-DD')
				}if(this.toDateField != '' && this.toDateField != 'Invalid date'){
					this.$parent.toDateField = moment(this.toDateField).format('YYYY-MM-DD')
				}if(this.fromDateField == '' || this.fromDateField == 'Invalid date'){
					this.$parent.fromDateField =  ''
				}if(this.toDateField == '' || this.toDateField == 'Invalid date'){
					this.$parent.toDateField =  ''
				}
				this.$parent.listing()
			},
            resetdata(){
                this.$parent.page = '1'
                this.$parent.search = ''
                this.$parent.pageLimit = '15'
                this.search = this.$parent.search
                this.pageLimit = this.$parent.pageLimit
                this.$parent.listing()
            },
        	limitFilterFunc(){
        		this.$parent.pageLimit = this.limit
                this.$parent.listing()
        	},
            searchFilterFun(){
            	this.$parent.search = this.search
                this.$parent.page = '1'
                this.$parent.listing()
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/shared/filterComponent.vue